import { useEffect, useState } from "react";
import { AssessmentsUserMenu } from "../../components/assessments-user-menu/assessments-user-menu";
import { BackControllerProvider, useBackController } from "../../components/back-controller/back-controller";
import BaseCardLayout from "../../components/base-card-layout/base-card-layout";
import LifestyleScreen from "../../components/lifestyle-screen/lifestyle-screen";
import { NavigationDirectionProvider, useNavigationDirection } from "../../components/navigation-direction-context/navigation-direction-content";
import { AssessmentUtils } from "../../utilities/assessments/assessment-utils";
import AssessmentSettings from "../../models/interfaces/assessment-settings";
import { Redirect, useHistory } from "react-router-dom";
import { useAuthState } from "../../utilities/contexts/auth-state-context";

const COMPONENT_CLASS = "p-lifestyle-assessment";

// ---------- LifestyleInner ----------
const LifestyleInner: React.FC = () => {
    const history = useHistory();
    const [settings, setSettings] = useState<AssessmentSettings>({
        completedGroupIds: [],
        currentSlideIndex: 0,
        currentGroupIndex: 0,
        questionResponses: [],
        slideGroups: [],
    });
    const { state } = useAuthState();
    const { setDirection } = useNavigationDirection();
    const { invoke } = useBackController();

    useEffect(() => {
        document.title = "Symmio Account";
    }, [])

    useEffect(() => {
        document.body.classList.add("-nav-hidden");

        return () => {
            document.body.classList.remove("-nav-hidden");
        };
    }, []);

    const onBackButtonClick = () => {
        if (invoke()) return;

        setDirection("backward");

        if (AssessmentUtils.isFirstSlideAndFirstGroup(settings)) {
            return history.goBack();
        }

        setSettings(AssessmentUtils.moveToPreviousPage(settings));
    };

    if (!state.authenticated) {
        return <Redirect to="/login" />;
    }

    if (state.user && state.user?.leadLinkId && state.user.organizationId === process.env.REACT_APP_LEAD_CAPTURE_ORG_ID) {
        return <Redirect to="/lc-assessment-results" />
    }

    return (
        <div className={COMPONENT_CLASS}>
            <div className={`user-menu hide-on-mobile`} style={{}}>
                <AssessmentsUserMenu profileImage={false} />
            </div>

            <BaseCardLayout>
                <LifestyleScreen
                    screenSettings={settings}
                    setScreenSettings={setSettings}
                    settingsOnBack={onBackButtonClick}
                />
            </BaseCardLayout>
        </div>
    );
};

// ---------- Root Lifestyle ----------
const Lifestyle: React.FC = () => {
    return (
        <NavigationDirectionProvider>
            <BackControllerProvider>
                <LifestyleInner />
            </BackControllerProvider>
        </NavigationDirectionProvider>
    );
};

export default Lifestyle;
